<template>
  <div>
    <div ref="anchor" style="margin-bottom: 2rem"></div>
    <HubSpotStep
      v-for="step in wizardSteps"
      :key="step"
      :current-step-id="step"
      :steps="wizardSteps"
      :brand="brand"
      v-on="$listeners"
      @scroll-to-anchor-emit="scrollToAnchor"
    />
  </div>
</template>

<script>
import HubSpotStep from '@/js/components/HubSpot/HubSpotStep.vue'

export default {
  name: 'HubSpotWizard',
  components: { HubSpotStep },
  props: {
    initialSteps: {
      type: String,
      default: 'co',
    },
    brand: {
      type: String,
      default: '',
    },
  },
  computed: {
    target() {
      return this.$refs.anchor
    },
    query() {
      return this.$route.query
    },
    queryFormName() {
      return this.query?.formName
    },
    querySteps() {
      return this.query?.steps
    },
    wizardSteps() {
      // return query steps or initial step
      if (this.querySteps) {
        return this.querySteps.split(',')
      } else {
        // If no query steps (caught by if condition above) but a form name is given in query, don't render initial step
        // else return and render initial step(s)
        const steps = !this.queryFormName ? this.initialSteps : undefined
        !this.queryFormName && this.pushInitalQuery(steps)
        return steps ? [steps] : []
      }
    },
  },
  methods: {
    pushInitalQuery(steps) {
      // push initial steps to query
      if (this.$route?.name !== 'default') {
        return
      }

      this.$router.push({
        query: { ...this.query, steps },
      })
    },
    scrollToAnchor() {
      this.$vuetify.goTo(this.target)
    },
  },
}
</script>
